var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"16px","color":"#1f5f8a"}},[_vm._v("\n  Lottoery (empty)\n")])}
var staticRenderFns = []

export { render, staticRenderFns }